module.exports = __webpack_public_path__ + "static/media/Discord-Logo-White.1c8a54f2.svg";